import $ from 'jquery'

export class GridCountdownTimer {

  constructor($container) {
    this.$container = $container

    this.$days = this.$container.find('.days .digits')
    this.$hours = this.$container.find('.hours .digits')
    this.$minutes = this.$container.find('.minutes .digits')
    this.$seconds = this.$container.find('.seconds .digits')

    this.date = new Date(this.$container.data('date')).getTime()

    this.handleChangeDate()

    this.interval = setInterval(this.handleChangeDate.bind(this), 1000)
  }

  handleChangeDate() {
    let now = new Date().getTime()
    let distance = this.date - now

    if (distance < 0) {
      clearInterval(this.interval)
      this.$container.css('opacity', '0')

      return
    }

    let days = Math.floor(distance / (1000 * 60 * 60 * 24))
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    let seconds = Math.floor((distance % (1000 * 60)) / 1000)

    this.updateNumber(this.$days, days.toString())
    this.updateNumber(this.$hours, hours.toString().padStart(2, '0'))
    this.updateNumber(this.$minutes, minutes.toString().padStart(2, '0'))
    this.updateNumber(this.$seconds, seconds.toString().padStart(2, '0'))
  }

  updateNumber($el, str) {
    const oldDigits = $el.find('.digit')
    this.newChars = str.split('')

    $el.empty()

    this.newChars.forEach(ch => {
      $el.append(this.makeDigit(ch))
    })

    oldDigits.each(this.eachOldDigits.bind(this))
  }

  eachOldDigits(i) {
    const $digit = $(this)
    const current = $digit.data('val')
    const next = this.newChars[i]

    if (current !== next) {
      // console.log('ANIM')
      this.animateDigit($digit, next)
    }
  }

  makeDigit(val) {
    const $digit = $('<div class="digit"></div>').data('val', val)
    const $stack = $('<div class="stack"></div>')

    $stack.append(`<div class="val new">${val}</div>`)

    $digit.append($stack)

    return $digit
  }

  animateDigit($digit, newVal) {
    const oldVal = $digit.data('val')

    $digit.data('val', newVal)

    const $stack = $digit.find('.stack')

    $stack
      .empty()
      .append(`<div class="val old">${oldVal}</div>`)
      .append(`<div class="val new">${newVal}</div>`)

    $digit.addClass('anim')

    setTimeout(() => {
      $digit.removeClass('anim')
    }, 400)
  }
}
